// extracted by mini-css-extract-plugin
module.exports =  {"root":"e273qA"};